import { connect } from 'react-redux';
import { selectDetailView, selectMenuAndReset, switchView, setFilters, searchMessages, resetMessageShown } from '../state/messagingActions';
import { getMessages } from 'src/ui/features/Messaging/state/messagingReselect';
import ToolbarPres from '../presentational/ToolbarPres';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import debounce from 'lodash.debounce';
import { MESSAGEORDER_TYPES, MESSAGEBOX_TYPES } from 'src/constants/constants';
import Grid from '@material-ui/core/Grid';
import BadgeWithCloseButton from 'src/new-ui/library/BadgeWithCloseButton/BadgeWithCloseButton.js';
import _ from 'lodash';
import { fnGetMessageValue } from 'src/helpers/commonFunctions';
import { setPillFilter } from 'src/ui/features/Messaging/state/messagingActions.js';
import { MESSAGE_NAV_CASE_NUMBER } from 'src/constants/constants';

class ToolbarContainer extends Component {
  static propTypes = {
    isCaseMessages: PropTypes.bool.isRequired,
    isComposeView: PropTypes.bool.isRequired,
    isDraftView: PropTypes.bool.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    inactiveCase: PropTypes.bool,
  };

  state = {
    filters: {
      fromContact: null,
      toContact: null,
      createdOn: null,
      searchText: '',
      sortDirection: MESSAGEORDER_TYPES.DESC,
      caseId: this.props.caseId,
    },
    pillFilter: {},
    defaultSelectedFilters: null,
    isFilterVisible: false,
  };

  constructor(props) {
    super(props);
    this.search = debounce(this.searchMessages, 250);
  }

  getSortDirection = () => {
    const selectedMenu = this.props.selectedMenu;
    let sortOrder = '';
    switch (selectedMenu) {
      case MESSAGEBOX_TYPES.INBOX: {
        sortOrder = this.props.inbox.filters.sortDirection;
        break;
      }
      case MESSAGEBOX_TYPES.SENT: {
        sortOrder = this.props.sent.filters.sortDirection;
        break;
      }
      case MESSAGEBOX_TYPES.draft: {
        sortOrder = this.props.draft.filters.sortDirection;
        break;
      }
      default: {
      }
    }
    return sortOrder;
  };

  componentDidMount() {
    const __GetCaseIdOnLoad = caseId => (caseId ? { type: 'MESSAGE_REDIRECTED', keys: [{ key: 'caseId', value: caseId }] } : null);
    let defaultSelectedFiltersObj = __GetCaseIdOnLoad(fnGetMessageValue());
    this.setState({ defaultSelectedFilters: defaultSelectedFiltersObj });
  }

  composeClicked = type => {
    this.props.selectDetailView(type);
    // switchView(MESSAGEBOX_VIEWS.DETAILS);
    this.props.toggleDrawer('right');
  };

  composeClickedLg = type => {
    if (this.props.countDrafts !== 0) selectMenuAndReset(this.props.selectedMenu);
    // resetMessageShown();
    this.props.selectDetailView(type);
  };

  applyFilters = filters => {
    this.setState(
      {
        filters,
      },
      () => {
        this.search();
      },
    );
  };

  searchMessages = () => {
    this.props.setFilters(this.state.filters);
    this.props.getMessages(this.props.state);
    this.props.searchMessages(this.props.selectedMenu);
  };

  filterConfig = () => {
    const { contacts, cases } = this.props.filters;
    const contactOpts = contacts ? contacts.map(item => ({ value: item.id, label: item.name })) : [];
    const casesOpts = cases ? cases.map(item => ({ value: item.id, label: item.name })) : [];

    const config = [
      { id: 'fromContact', controlType: 'Dropdown', label: intl.get('messaging.filters.labels.from'), options: contactOpts },
      { id: 'toContact', controlType: 'Dropdown', label: intl.get('messaging.filters.labels.to'), options: contactOpts },
      { id: 'createdOn', controlType: 'Date', label: intl.get('messaging.filters.labels.createdOn') },
      { id: 'caseId', controlType: 'Dropdown', label: intl.get('messaging.filters.labels.caseNumber'), options: casesOpts },
      // { id: 'flagStatus', controlType: 'Dropdown', label: intl.get('messaging.filters.labels.flagStatus') },
    ];

    return config;
  };

  handleFilterSearch = searchText => {
    let filters = this.state.filters;
    filters.searchText = searchText;
    this.applyFilters(filters);
  };

  handleFilterApply = filters => {
    let sortOrder = this.getSortDirection();
    this.setState(
      prevState => ({
        filters: { ...prevState.filters, sortDirection: sortOrder },
      }),
      () => {
        this.applyFilters({
          ...this.state.filters,
          ...filters,
        });

        this.setState(
          prevState => ({
            pillFilter: filters,
          }),
          () => {
            let caseNumber = sessionStorage.getItem(MESSAGE_NAV_CASE_NUMBER);
            if (caseNumber) {
              this.props.setPillFilter(caseNumber);
              sessionStorage.removeItem(MESSAGE_NAV_CASE_NUMBER);
            } else {
              const caseId = this.props.filters.cases;
              let caseDetails = _.find(caseId, e => e.id === this.state.pillFilter.caseId);
              this.props.setPillFilter(caseDetails ? caseDetails.name : '');
            }
          },
        );
      },
    );
  };

  handleFilterClear = () => {
    let sortOrder = this.getSortDirection();
    let resetFilter = {
      ...this.state.filters,
      fromContact: null,
      toContact: null,
      createdOn: null,
      sortDirection: sortOrder,
      caseId: null,
    };
    this.setState(
      {
        filters: resetFilter,
        pillFilter: {},
      },
      () => {
        this.props.setPillFilter('');
      },
    );
    this.applyFilters(resetFilter);
  };

  disableNewMessage = () => {
    const { isComposeView, isDraftView, inactiveCase } = this.props;
    return isComposeView || isDraftView || inactiveCase;
  };

  getPillComponent = () => {
    let PillComponent = [];
    if (this.state.pillFilter) {
      for (let [key, value] of Object.entries(this.state.pillFilter)) {
        let displayText = '';

        switch (key) {
          case 'caseId': {
            const caseId = this.props.filters.cases;
            let caseDetails = _.find(caseId, e => e.id === value);
            value = caseDetails ? caseDetails.name : '';
            displayText = 'Case number';
            break;
          }
          case 'createdOn': {
            displayText = 'Date';
            break;
          }
          case 'fromContact': {
            const fromContact = this.props.filters.contacts;
            value = _.find(fromContact, e => e.id === value).name;
            displayText = 'From';
            break;
          }
          case 'toContact': {
            const toContact = this.props.filters.contacts;
            value = _.find(toContact, e => e.id === value).name;
            displayText = 'To';
            break;
          }
          default: {
          }
        }
        if (value) {
          PillComponent.push(
            <BadgeWithCloseButton labelLeft={key} labelRight={value} displayText={displayText} onClickTest={this.handlePillClick} />,
          );
        }
      }
      return PillComponent;
    }
  };

  handlePillClick = key => {
    let removeFromPill = this.state.pillFilter;
    delete removeFromPill[key];

    let resetFilter = {
      ...this.state.filters,
      [key]: null,
    };
    this.setState(
      {
        pillFilter: removeFromPill,
      },
      () => {
        this.applyFilters(resetFilter);
        if (key === 'caseId') {
          this.props.setPillFilter('');
        }
      },
    );
  };

  handleFilterVisibility = () => {
    this.setState({
      isFilterVisible: !this.state.isFilterVisible,
    });
  };

  render() {
    return (
      <React.Fragment>
        <ToolbarPres
          {...this.props}
          composeClicked={this.composeClicked}
          onSearchMessages={this.onSearchMessages}
          composeClickedLg={this.composeClickedLg}
          filterConfig={this.filterConfig()}
          onFilterSearch={this.handleFilterSearch}
          onFilterApply={this.handleFilterApply}
          onFilterClear={this.handleFilterClear}
          disableNewMessage={this.disableNewMessage()}
          pageType={'messaging'}
          defaultSelectedFilters={this.state.defaultSelectedFilters}
          onFilter={this.handleFilterVisibility}
          isShowFilterOptions={this.state.isFilterVisible}
        />
        <Grid container direct="row" className="pill-container">
          <Grid item xs={8}>
            {this.getPillComponent()}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  detailType: state.messaging.detailType,
  isMobile: ownProps.isMobile,
  currentView: state.messaging.currentView,
  selectedMenu: state.messaging.selectedMenu,
  countDrafts: state.messaging.countDrafts,
  filters: state.messaging.filters,
  drawerState: state.utils.drawerState,
  isTablet: state.browser.greaterThan.small && state.browser.lessThan.extraLarge,
  mediaType: state.browser.mediaType,
  showToastMessage: state.messaging.showToastMessage,
  toastMessage: state.messaging.toastMessage,
  userInfo: state.login.userInfo,
  casesMessages: state.messaging.casesMessages,
  caseId: state.cases.caseDetails.caseId,
  caseManagerId: state.cases.caseManagerId,
  selectedMessageId: state.dashboard.selectedMessageId,
  state: state,
  inbox: state.messaging.inbox,
  sent: state.messaging.sent,
  draft: state.messaging.draft,
});

const mapDispatchToProps = {
  selectDetailView,
  switchView,
  selectMenuAndReset,
  resetMessageShown,
  searchMessages,
  getMessages,
  setFilters,
  setPillFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarContainer);
